import(/* webpackMode: "eager" */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/app/global-error.tsx");
